import { render } from "./fileInputMultiple.vue?vue&type=template&id=2dac23c8&ts=true"
import script from "./fileInputMultiple.vue?vue&type=script&lang=ts"
export * from "./fileInputMultiple.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__